import { gate } from 'hub-http/gates';
const METRICS_GATE = gate('CRM:Properties:FieldEditPerfMetrics');
const DEBUG_GATE = gate('CRM:Properties:FieldEditPerfMetricsDebug');
const SESSION_SAMPLE_RATE = 0.2;
const TYPED_INPUT_SAMPLE_RATE = 0.1;
let initialized = false;
let isSessionSampled = false;
let isDebugMode = false;
let isMetricsEnabled = false;
let lastHiddenAt = -Infinity;
let visibilityChangeHandler = null;
export const initFieldEditPerfSampling = getIsUngated => {
  if (initialized) {
    return;
  }
  initialized = true;
  visibilityChangeHandler = () => {
    if (document.hidden) {
      lastHiddenAt = performance.now();
    }
  };
  document.addEventListener('visibilitychange', visibilityChangeHandler);
  isDebugMode = getIsUngated(DEBUG_GATE);
  isMetricsEnabled = getIsUngated(METRICS_GATE);
  if (isDebugMode) {
    isSessionSampled = true;
    return;
  }
  if (!isMetricsEnabled) {
    isSessionSampled = false;
    return;
  }
  isSessionSampled = Math.random() < SESSION_SAMPLE_RATE;
};
export const shouldSampleOnChange = autosaveEvent => {
  if (!isSessionSampled) {
    return false;
  }
  if (isDebugMode) {
    return true;
  }
  if (autosaveEvent === 'close') {
    return true;
  }
  return Math.random() < TYPED_INPUT_SAMPLE_RATE;
};
export const shouldSampleAutosave = () => {
  return isSessionSampled;
};
export const shouldLogToConsole = () => {
  return isDebugMode;
};
export const wasPageHiddenSince = startTime => {
  return lastHiddenAt > startTime;
};
export const resetFieldEditPerfSampling = () => {
  if (visibilityChangeHandler) {
    document.removeEventListener('visibilitychange', visibilityChangeHandler);
    visibilityChangeHandler = null;
  }
  initialized = false;
  isSessionSampled = false;
  isDebugMode = false;
  isMetricsEnabled = false;
  lastHiddenAt = -Infinity;
};
export const bucketFieldCount = count => {
  if (count <= 0) {
    return '0';
  }
  if (count > 300) {
    return '300+';
  }
  const lower = Math.floor((count - 1) / 25) * 25 + 1;
  const upper = lower + 24;
  return `${lower}-${upper}`;
};